export default __webpack_public_path__ + "static/media/element_86.2e129425.webp";